<template>
    <div :id="$style.methods">
        <h3>{{ $t("forms.ticket.labels.payment_method") }}</h3>
        <PaymentLogos />
        <h3>{{ $t("forms.ticket.labels.via") }}</h3>
    </div>
</template>

<script>
import PaymentLogos from "./PaymentLogos";

export default {
    name: "PaymentMethodTitle",
    components: {
        PaymentLogos
    },
};
</script>

<style module lang="postcss">
    #methods {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: center;
        grid-gap: initial;
    }

    #methods > h3 {
        font-size: 16px;
        font-weight: 500;
        display: block;
        margin: 0;
        padding: 0;
    }
</style>